import React, { useEffect, useRef } from "react";

const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const DEFAULT_PLAN = process.env.REACT_APP_PAYPAL_PLAN_UNLIMITED;

let sdkPromise = null;
function loadSdk() {
    if (window.paypal) return Promise.resolve();
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = `https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&vault=true&intent=subscription`;
        s.setAttribute("data-sdk-integration-source", "button-factory");
        s.onload = resolve;
        s.onerror = reject;
        document.body.appendChild(s);
    });
    return sdkPromise;
}

export default function PayPalSubscribeButton({ onApproved, planId, tier }) {
    const ref = useRef(null);
    const plan = planId || DEFAULT_PLAN;
    useEffect(() => {
        let mounted = true;
        loadSdk()
            .then(() => {
                if (!mounted || !window.paypal || !ref.current) return;
                ref.current.innerHTML = "";
                window.paypal
                    .Buttons({
                        style: { shape: "pill", color: "gold", layout: "vertical", label: "subscribe" },
                        createSubscription: (data, actions) => actions.subscription.create({ plan_id: plan }),
                        onApprove: (data) => onApproved(data.subscriptionID, tier),
                    })
                    .render(ref.current);
            })
            .catch(() => {});
        return () => { mounted = false; };
    }, [plan, tier]); // eslint-disable-line
    return <div ref={ref} data-testid={`paypal-button-${tier || "default"}`} />;
}
